<template>
    <div class="viewport">
        <md-toolbar :md-elevation="1">
            <span class="md-title md-list-item-text primary">Product</span>
            <md-button
                @click="showDialogSelectProduct = true"
                class="md-icon-button md-list-action"
                v-if="!selectedProduct"
            >
            </md-button>
        </md-toolbar>

        <md-dialog style="z-index: 9" :md-active.sync="showDialogSelectProduct">
            <md-dialog-title>Select Product </md-dialog-title>

            <md-dialog-content>
                <md-list>
                    <md-list-item>
                        <product-search-modal
                            @set-selected-product="setSelectedProduct($event)"
                            style="padding-left: 15px; z-index: 1000"
                        >
                        </product-search-modal>
                    </md-list-item>
                </md-list>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button @click="cancelSelectProduct()" class="md-primary">Cancel</md-button>
                <md-button @click="addSelectedProduct()" class="md-primary">Save</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import ClientCard from '@/components/client/ClientCard.vue';
import { IInventoryEntity, IProductEntity } from '@phrospr/lib-models';
import { inventoryStore } from '@/store/inventory/inventory.store';
import ProductSearchModal from '@/components/product-search-modal/ProductSearchModal.vue';

@Component({
    components: { ProductSearchModal, ClientCard, ClientSearchModal },
})
export default class InventoryProduct extends Vue {
    @Prop() private inventory: IInventoryEntity;

    showDialogSelectProduct = false;

    sending = false;

    get selectedProduct() {
        return inventoryStore.state.selectedProduct;
    }

    get isExistingInventory() {
        return this.inventory.inventory_id !== null;
    }

    constructor() {
        super();
        this.load();
    }

    private async load() {}

    public async cancelSelectProduct() {
        this.showDialogSelectProduct = false;
    }

    public async addSelectedProduct() {
        this.inventory.product_id = this.selectedProduct.product_id;
        this.showDialogSelectProduct = false;
    }

    setSelectedProduct(product: IProductEntity) {
        inventoryStore.commit('setSelectedProduct', product);
    }

    reset() {
        inventoryStore.commit('setSelectedProduct', null);
        this.inventory.product_id = undefined;
    }
}
</script>

<style lang="scss" scoped></style>
